
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersNight as ObiLightningSleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-night.js';
 
 
 

 
 export const ObiLightningSleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-night',
   elementClass: ObiLightningSleetShowersNightElement,
   events: {
     
   }
  });
 
 